import { ThemeOptions } from '@material-ui/core';

/**
 * This is a workaround to reset the default styling of MUI components.
 * Without this we can't use Tailwind classes to style certain properties without forcing the use of !important.
 * Once we've upgraded to MUI v5 we can remove this and use their unstyled components where we need to.
 * Upgrade to MUI v5: https://linear.app/treet/issue/TREET-9845/upgrade-material-ui-to-5
 */
export const defaultTooltipStylingReset: ThemeOptions['overrides'] = {
  MuiTooltip: {
    tooltip: {
      backgroundColor: undefined,
      color: undefined,
      padding: undefined,
      fontSize: undefined,
      maxWidth: undefined,
      wordWrap: undefined,
      fontFamily: undefined,
      fontWeight: undefined,
      lineHeight: undefined,
      borderRadius: undefined,
    },
  },
};
